export default "__VITE_ASSET__5T_6sBWR__"